import CreateHub from './CreateHub'

export default CreateHub
